
import Vue from 'vue';
import PollAnswer from './PollAnswer.vue';

export interface Vote {
    text:string,
    selected:boolean
}

export default Vue.extend({
    components: {
        PollAnswer
    },

    props: {
        question: {
            type: String,
            required: true,
        },
        votes: {
            type: Array,
            required: true,
        }
    }
});
